import { graphql } from "react-relay";

export const GENERATE_JWT_FOR_USER_MUTATION = graphql`
	mutation useAuthContext_GenerateJWTForUserMutation($input: GenerateJWTForUserInput!) {
		Auth {
			generateJWTForUser(input: $input) {
				jwtTokens {
					accessToken
					refreshToken
				}
			}
		}
	}
`;
